// @flow
import * as React from "react"
import { ModalHeaderWrap, LeftIconWrap, RightIconWrap, ModalTitle } from "./styled"
import StyledLink from "components/StyledLink"
import CrossIcon from "assets/icons/CrossIcon"
import ArrowIcon from "assets/icons/ArrowIcon"

type Props = {|
  close?: Function,
  back?: Function,
  title: string,
  clear?: Function,
  children?: React.Node,
|}

const ModalHeader = ({ close, back, title, clear, children }: Props) => (
  <ModalHeaderWrap>
    {close && (
      <LeftIconWrap onClick={close}>
        <CrossIcon />
      </LeftIconWrap>
    )}
    {back && (
      <LeftIconWrap onClick={back}>
        <ArrowIcon rotation="left" />
      </LeftIconWrap>
    )}
    <ModalTitle>{title}</ModalTitle>
    {clear && (
      <RightIconWrap>
        <StyledLink onClick={clear}>Clear</StyledLink>
      </RightIconWrap>
    )}
    {children && <RightIconWrap>{children}</RightIconWrap>}
  </ModalHeaderWrap>
)

export default ModalHeader



// WEBPACK FOOTER //
// ./src/modals/_Header/index.js